export default "<audio style=\"width: 100% !important\" [src]=\"src\" controls ontrolsList=\"nodownload\"\n  (contextmenu)=\"onRightClick($event)\"></audio>\n";